import React, {useEffect, useRef, useState} from 'react';
import * as Data from "./get_section_content"
import {GetDescription, GetProcessID, GetAssetID} from "./get_section_content";

const path_to_audio = "./mia/assets/";

export default Sounds;
function Sounds({section, onPlay})
{
    const [currentPlaying, setCurrentPlaying] = useState(null);

    useEffect(() => {
        setCurrentPlaying(GetAssetID(section));
    }, [section])
    
    function handleOnPlay(audioElement)
    {
       if (audioElement) onPlay(audioElement);
    }
    
    return (
        <>
            <div id={"soundsContainer"}>
                {/* Create audio holders based on audioAssetNames */}
                {Data.AssetIDs.map(id => (
                    <AudioHolder id={id} key={id} currentPlaying={currentPlaying} onPlay={handleOnPlay}/>                    
                ))}                
            </div>
        </>
    )
}

function AudioHolder({id, currentPlaying, onPlay}) {
    const audioRef = useRef(null);
    
    useEffect(() => {
        if (currentPlaying === id) {
            if (audioRef.current) onPlay(audioRef.current);
            audioRef.current.play();            
        } else {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
    }, [currentPlaying, id, onPlay]);

    return <audio 
        ref={audioRef} 
        src={path_to_audio + id + ".mp3"} 
        />;
}